import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { usePricing, euro } from "@/lib/pricing";
import { Sparkles, X } from "lucide-react";

/** v11 · Aviso discreto de la oferta del Pro, solo para cuentas en plan Gratis. Se puede cerrar. */
export default function OfferBanner() {
  const { user } = useAuth();
  const pricing = usePricing();
  const offer = pricing.offer;
  const key = offer ? `ca_offer_closed_${offer.ends_at}_${offer.monthly}` : "";
  const [closed, setClosed] = useState(() => {
    try { return key ? localStorage.getItem(key) === "1" : false; } catch { return false; }
  });
  if (!offer || user?.plan !== "gratis" || closed) return null;
  const close = () => {
    setClosed(true);
    try { localStorage.setItem(key, "1"); } catch { /* sin almacenamiento: solo se oculta ahora */ }
  };
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-brand-accent/40 bg-brand-accent/[0.06] px-4 py-2.5 text-sm" data-testid="offer-banner">
      <span className="flex items-center gap-2.5 text-brand-ink">
        <Sparkles size={15} className="shrink-0 text-brand-accent" />
        <span>
          <b>{offer.label}:</b> Pro a <b>{euro(offer.monthly)} €/mes</b>
          <span className="text-brand-muted"> (antes {euro(pricing.pro.monthly)} €)</span>
          {offer.ends_label && <span className="text-brand-muted"> · {offer.ends_label.toLowerCase()}</span>}
        </span>
      </span>
      <span className="flex shrink-0 items-center gap-3">
        <Link to="/app/cuenta" className="text-xs font-semibold text-brand-accent" data-testid="offer-banner-link">Ver planes</Link>
        <button onClick={close} aria-label="Cerrar aviso" className="text-brand-muted hover:text-brand-ink"><X size={14} /></button>
      </span>
    </div>
  );
}
